import gql from 'graphql-tag';
const CREATE_HASHED_EMAIL_LIST = gql`
  mutation createHashedEmailList(
    $name: String!
    $hashedEmailIds: [HashedEmailAddressWhereUniqueInput!]
    $orgID: ID!
    $stepProgress: Int
    $status: EnumFirstPartyDataStatus
    $typeOfFirstPartyData: String
    $tag: String
    $uploadedAt: DateTime
    $csvFileName: String
    $dsp: EnumFirstPartyDataDSP
  ) {
    createHashedEmailList(
      data: {
        name: $name
        hashedEmails: { connect: $hashedEmailIds }
        typeOfFirstPartyData: $typeOfFirstPartyData
        orgs: { connect: [{ id: $orgID }] }
        stepProgress: $stepProgress
        status: $status
        tag: $tag
        uploadedAt: $uploadedAt
        csvFileName: $csvFileName
        dsp: $dsp
      }
    ) {
      id
      name
      stepProgress
      status
      tag
      uploadedAt
      csvFileName
      dsp
    }
  }
`;

export default CREATE_HASHED_EMAIL_LIST;
